import React from 'react'
import { Element } from 'react-scroll'
import styled from 'styled-components'
import Layout from '~shared/Layout'
import ScrollEncourager from '~shared/ScrollEncourager'
import Hero from './Hero'
import Offices from './Offices'
import Team from './Team'

const UnstyledAbout = (props) => {
    return (
        <Layout {...props} $backgroundColor="white">
            <Hero />
            <Element name={ScrollEncourager.TargetID} />
            <Team />
            <Offices />
        </Layout>
    )
}

const About = styled(UnstyledAbout)`
    color: #0c009a;
`

export default About
